<template>
  <div>
    <van-nav-bar title="群组成员"
      left-arrow
      @click-left="
            $router.push({ name: 'ChannelDetails', params: { chennelNo: chennelId } })
          "
      >
      <template #right>
        <van-icon
          name="search"
          color="#ffffff"
          size="24px"
          @click="$router.push({ name: 'ChannelMemberSearch', params: { chennelNo: chennelId } })"
        />
      </template>
      </van-nav-bar>
     <van-list 
        :key="$t('app.common.loading')"
        v-model="isLoading" 
        @load="getChannelMemberList" 
        :finished="finished" 
        :finished-text="$t('app.common.finished')" 
        :loading-text="$t('app.common.loading')"
      >
     <div>
            <van-row v-for="(item, index) in memberList" :key="index" class="rowDesign"
            @click="$router.push({ name: 'ChannelMemberDetails', params: { userId: item.account, chennelId:chennelId } })">
                <van-col span="6" style="text-align: center;" class="channelUserStyle">
                    <img :src="item.avatar" class="imageStyle" />
                </van-col>
                <van-col span="18" style="text-align: left;">
                    <van-row class="channelUserRowStyle">
                    <span v-if="item.name">{{item.name}}</span>
                    <span v-else>{{item.account}}</span>
                    </van-row>
                </van-col>
            </van-row>
    </div>
    </van-list>  
  </div>
</template>

<script>
export default {
  name: "ChannelMembers",
  data() {
    return {
      chennelId:"",
      memberList:[],
      isLoading:false,
      finished:false,
      page:0
    };
  },
  computed: {},
  methods: {
    getChannelMemberList(){
      let that = this;
      let page = that.page;
      let chennelId = that.chennelId;
      that
      .$wonderChat({
          url: "api/group/member/list/"+chennelId+"/"+page,
          method: "post",
          headers: {
            "access-token": that.$store.state.wonder_chat_token,
          },
          data: {
            keyword:""
          },
        })
        .then((res) => {
          let resData = res.data; 
          that.isLoading = false;
              if (resData.code == 200) {
                that.page = page + 1;
                that.memberList = that.memberList.concat(resData.dataList); 
                if (resData.dataList.length < 20){
                   that.finished = true;
                }
              } else {
                that.$toast.fail(that.$t(resData.msg));
              }
        })
        .catch(()=>{
              that.isLoading = false; 
              that.finished = true;
              that.$toast.fail(that.$NoNetworkErrorMsg)
        })
    },
    isLogin() {
      if (!this.$store.state.loginType) {
        this.$router.push("/login");
      }
    },
  },
  mounted: function () {
    this.isLogin();
    this.chennelId = this.$route.params.account;
  },
};
</script>

<style scoped>

.rowDesign {
  padding: 4px 10px;
  border-bottom: 1px solid #dcdee0;
}

.imageStyle {
  width: 40px;
  border-radius: 25px;
}

.channelUserStyle {
  text-align: left;
  padding-right: 10px;
}

.channelUserRowStyle {
  padding-top: 12px;
  color: #000000;
}
</style>


// WEBPACK FOOTER //
// src/components/ChannelMembers.vue